var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mini-article"},[(_vm.loading)?_c('Loading',{attrs:{"count":6}}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.detail.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }